// Central data source for all 28 suburb landing pages.
// Each suburb gets a unique localized intro + a regional grouping so the
// pages don't read as duplicate content.

export const REGIONS = {
  bayside: {
    label: "Bayside & Mornington Peninsula",
    blurb:
      "Coastal weather, salty air and acreage blocks — your fence needs to be built to handle every season, not just summer.",
  },
  south_east: {
    label: "South East Growth Corridor",
    blurb:
      "New-build estates moving fast — we measure quick, build clean, and leave the site tidier than we found it.",
  },
  gippsland_west: {
    label: "West Gippsland",
    blurb:
      "Rolling country between Pakenham and Warragul — hardwood posts, proper drainage, and fences that stand up to the wind.",
  },
  gippsland_east: {
    label: "East & South Gippsland",
    blurb:
      "From dairy country to the Latrobe Valley and the coast — we travel out for jobs worth doing properly.",
  },
};

export const SUBURBS = [
  // Bayside & Mornington Peninsula
  { slug: "frankston", name: "Frankston", region: "bayside", vibe: "the bay-edge gateway", postcode: "3199" },
  { slug: "mornington", name: "Mornington", region: "bayside", vibe: "Peninsula main street", postcode: "3931" },
  { slug: "mt-eliza", name: "Mt Eliza", region: "bayside", vibe: "leafy bayside hills", postcode: "3930" },
  { slug: "hastings", name: "Hastings", region: "bayside", vibe: "Westernport waterfront", postcode: "3915" },
  { slug: "rosebud", name: "Rosebud", region: "bayside", vibe: "back-beach holiday country", postcode: "3939" },
  { slug: "dromana", name: "Dromana", region: "bayside", vibe: "foreshore towns under Arthurs Seat", postcode: "3936" },
  { slug: "cowes", name: "Cowes", region: "bayside", vibe: "Phillip Island's main hub", postcode: "3922" },
  { slug: "phillip-island", name: "Phillip Island", region: "bayside", vibe: "the whole island", postcode: "3922" },

  // South East Growth Corridor
  { slug: "cranbourne", name: "Cranbourne", region: "south_east", vibe: "new estates & old farmland", postcode: "3977" },
  { slug: "pakenham", name: "Pakenham", region: "south_east", vibe: "south east boom suburb", postcode: "3810" },
  { slug: "berwick", name: "Berwick", region: "south_east", vibe: "established homes & heritage strips", postcode: "3806" },
  { slug: "officer", name: "Officer", region: "south_east", vibe: "growth-corridor new builds", postcode: "3809" },
  { slug: "beaconsfield", name: "Beaconsfield", region: "south_east", vibe: "leafy half-acre blocks", postcode: "3807" },
  { slug: "narre-warren", name: "Narre Warren", region: "south_east", vibe: "the south east heartland", postcode: "3805" },
  { slug: "clyde", name: "Clyde", region: "south_east", vibe: "fast-growing south east estates", postcode: "3978" },
  { slug: "tooradin", name: "Tooradin", region: "south_east", vibe: "the rural fringe", postcode: "3980" },
  { slug: "koo-wee-rup", name: "Koo Wee Rup", region: "south_east", vibe: "potato country", postcode: "3981" },
  { slug: "lang-lang", name: "Lang Lang", region: "south_east", vibe: "the Westernport farmlands", postcode: "3984" },

  // West Gippsland
  { slug: "drouin", name: "Drouin", region: "gippsland_west", vibe: "the gateway to Gippsland", postcode: "3818" },
  { slug: "warragul", name: "Warragul", region: "gippsland_west", vibe: "the West Gippsland capital", postcode: "3820" },
  { slug: "moe", name: "Moe", region: "gippsland_west", vibe: "Latrobe Valley townships", postcode: "3825" },
  { slug: "korumburra", name: "Korumburra", region: "gippsland_west", vibe: "the South Gippsland hills", postcode: "3950" },

  // East & South Gippsland
  { slug: "leongatha", name: "Leongatha", region: "gippsland_east", vibe: "South Gippsland dairy country", postcode: "3953" },
  { slug: "wonthaggi", name: "Wonthaggi", region: "gippsland_east", vibe: "the Bass Coast hub", postcode: "3995" },
  { slug: "inverloch", name: "Inverloch", region: "gippsland_east", vibe: "South Gippsland coast", postcode: "3996" },
  { slug: "traralgon", name: "Traralgon", region: "gippsland_east", vibe: "the Latrobe Valley big smoke", postcode: "3844" },
  { slug: "sale", name: "Sale", region: "gippsland_east", vibe: "Wellington Shire centre", postcode: "3850" },
  { slug: "bairnsdale", name: "Bairnsdale", region: "gippsland_east", vibe: "East Gippsland gateway", postcode: "3875" },
];

export function getSuburbBySlug(slug) {
  return SUBURBS.find((s) => s.slug === slug);
}

export function getNearbySuburbs(slug, count = 6) {
  const current = getSuburbBySlug(slug);
  if (!current) return SUBURBS.slice(0, count);
  // Prefer same-region neighbours, then fill from other regions
  const sameRegion = SUBURBS.filter((s) => s.region === current.region && s.slug !== slug);
  const otherRegions = SUBURBS.filter((s) => s.region !== current.region);
  return [...sameRegion, ...otherRegions].slice(0, count);
}
